import { jsx as o, jsxs as Y } from "react/jsx-runtime";
import { useState as f } from "react";
import "@mui/material/Button";
import "@mui/material/styles";
import "@mui/material/CssBaseline";
import { d as j, I as C } from "./Slider-vVmtecg6.js";
import { Box as p, LinearProgress as L } from "@mui/material";
import "@mui/material/useAutocomplete";
import { faXmark as T } from "@fortawesome/pro-regular-svg-icons";
import "@emotion/cache";
import "@emotion/react";
import "@mui/material/Box";
import "@mui/material/Typography";
import "@fortawesome/fontawesome-svg-core";
import "@mui/material/Checkbox";
import "@fortawesome/pro-solid-svg-icons";
import "@fortawesome/pro-light-svg-icons";
import "@mui/material/Stack";
import "@mui/material/Link";
import "@mui/material/Tooltip";
import "@mui/material/Fade";
import "@fortawesome/pro-regular-svg-icons/faXmark";
import "@mui/material/Chip";
import "@fortawesome/pro-solid-svg-icons/faCircle";
import "@mui/material/Avatar";
import "@fortawesome/pro-light-svg-icons/faUser";
import "@mui/material/AvatarGroup";
import "@fortawesome/pro-regular-svg-icons/faPlus";
import "@mui/material/LinearProgress";
import "@mui/material/Tabs";
import "@mui/material/Tab";
import "./Tab-CO75KpXL.js";
import "@mui/material/ButtonGroup";
import "@mui/material/Switch";
import "@mui/material/Radio";
import "@mui/material/FormLabel";
import "@mui/material/Autocomplete";
import "@mui/material/FormHelperText";
import "@mui/material/FormControl";
import "@mui/material/OutlinedInput";
import "@mui/material/Input";
import "@mui/material/InputAdornment";
import "@fortawesome/pro-regular-svg-icons/faMagnifyingGlass";
import "@fortawesome/pro-solid-svg-icons/faCheck";
import "@fortawesome/pro-regular-svg-icons/faCircleQuestion";
import "@react-spring/web";
import "./ContentPanel-DRC79oum.js";
import "react-dropzone";
import "@vidstack/react";
import "@vidstack/react/player/layouts/default";
import "@vidstack/react/player/styles/default/theme.css";
import "@vidstack/react/player/styles/default/layouts/video.css";
import "@vidstack/react/icons";
import "@fortawesome/pro-light-svg-icons/faArrowUpRightFromSquare";
import "@fortawesome/pro-solid-svg-icons/faArrowRight";
import "@mui/material/Popper";
import "@fortawesome/pro-regular-svg-icons/faLinkSimple";
import "copy-text-to-clipboard";
import "@fortawesome/pro-solid-svg-icons/faExpandWide";
import "@fortawesome/pro-solid-svg-icons/faCompressWide";
import "@fortawesome/pro-solid-svg-icons/faUpRightAndDownLeftFromCenter";
import "@fortawesome/pro-solid-svg-icons/faDownLeftAndUpRightToCenter";
import "@fortawesome/pro-solid-svg-icons/faChevronsRight";
import "@fortawesome/pro-solid-svg-icons/faChevronsLeft";
import "@fortawesome/pro-solid-svg-icons/faToggleLargeOn";
import "@fortawesome/pro-solid-svg-icons/faToggleOff";
import "@fortawesome/pro-solid-svg-icons/faEye";
import "react-use";
import "color";
import { F as W, L as z, T as A } from "./ThankYouStep-3OA2S8P0.js";
import "react-rnd";
import "react-hotkeys-hook";
import "./AutoScrollContainer-CzyjIY1o.js";
import "@tanstack/react-table";
import "@fortawesome/pro-regular-svg-icons/faArrowRight";
import "@fortawesome/pro-regular-svg-icons/faArrowLeft";
import "@fortawesome/pro-regular-svg-icons/faPenToSquare";
import "@fortawesome/pro-regular-svg-icons/faCircleXmark";
import "@fortawesome/pro-regular-svg-icons/faArrowDown";
import "@mui/material/Slider";
const r = {
  feedback: 0,
  singIn: 1,
  thankYou: 2
}, eo = ({
  isLoading: c,
  onClose: h,
  authorName: m,
  shouldHideCreatorIdentity: n = !1,
  authorPhotoURL: k = "",
  isMobileView: t,
  background: g = "",
  shouldHidePolicyAndTermsLink: u = !1,
  onPostClick: x,
  onPostAnonymously: b,
  onGoogleClick: s = void 0,
  onMicrosoftClick: l = void 0,
  onSingUpClick: d = void 0,
  termsLink: v,
  privacyPolicyLink: y,
  isBackgroundLight: I = !1
}) => {
  const S = n ? "Thank you 👍!" : `Thank you ${m} 👍!`, [i, F] = f(S), [e, a] = f(r.feedback);
  return /* @__PURE__ */ o(
    p,
    {
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      children: /* @__PURE__ */ Y(
        p,
        {
          maxWidth: t ? "calc(100% - 16px)" : "500px",
          maxHeight: `calc(100% - ${t ? 16 : 40}px)`,
          bgcolor: (P) => P.palette.background.paper,
          width: "100%",
          height: "auto",
          overflow: "hidden",
          borderRadius: "8px",
          position: "relative",
          display: t ? "flex" : "block",
          justifyContent: "center",
          alignItems: "center",
          children: [
            !!c && /* @__PURE__ */ o(
              p,
              {
                position: "absolute",
                top: 0,
                right: 0,
                left: 0,
                children: /* @__PURE__ */ o(L, {})
              }
            ),
            /* @__PURE__ */ o(
              p,
              {
                position: "absolute",
                top: t ? 0 : 14,
                right: t ? 8 : 14,
                children: /* @__PURE__ */ o(
                  j,
                  {
                    label: "Close",
                    onClick: h,
                    variant: "text",
                    color: "secondary",
                    size: "large",
                    children: /* @__PURE__ */ o(
                      C,
                      {
                        icon: T,
                        size: "xs"
                      }
                    )
                  }
                )
              }
            ),
            e === r.feedback && /* @__PURE__ */ o(
              W,
              {
                shouldHideCreatorIdentity: n,
                authorName: m,
                setFeedback: F,
                isMobileView: t,
                feedback: i,
                onPost: () => {
                  x(i), a(r.singIn);
                }
              }
            ),
            e === r.singIn && /* @__PURE__ */ o(
              z,
              {
                shouldHideCreatorIdentity: n,
                authorName: m,
                isBackgroundLight: I,
                shouldHidePolicyAndTermsLink: u,
                authorPhotoURL: k,
                background: g,
                isMobileView: t,
                googleLabel: t ? "Google" : "Continue with Google",
                microsoftLabel: t ? "Microsoft" : "Continue with Microsoft",
                ...s && {
                  onGoogleClick: () => {
                    s(i);
                  }
                },
                ...l && {
                  onMicrosoftClick: () => {
                    l(i);
                  }
                },
                onPostAnonymously: () => {
                  b(i), a(r.thankYou);
                },
                ...d && {
                  onSingUpClick: () => {
                    a(r.thankYou), d(i);
                  }
                },
                termsLink: v,
                privacyPolicyLink: y,
                isLoading: c
              }
            ),
            e === r.thankYou && /* @__PURE__ */ o(A, { isMobileView: t })
          ]
        }
      )
    }
  );
};
export {
  eo as P
};
